import { useMemo } from 'react'
import { unique } from 'lib/array/arrayUtils'
import useOffers from 'hooks/Offers/useOffers'
import { excludeNullOrUndefined } from 'checkout/utils'

export default function useSearchMapResults(
  selectedOfferIds: Array<string>,
  overrideOfferList?: App.OfferList,
  pageSize: number = 20,
  offerList?: App.OfferList,
) {
  const offerIds = useMemo(() => {
    if (!offerList?.fetching && overrideOfferList) {
      return unique([...overrideOfferList.offerIds, ...selectedOfferIds])
    }
    return []
  }, [offerList?.fetching, overrideOfferList, selectedOfferIds])

  const [loadedOffers, offersFetching] = useOffers<App.HotelOffer | App.BedbankOffer>(offerIds)

  const offers = useMemo(() => {
    const loadedOfferMap = new Map(loadedOffers.map(offer => [offer.id, offer]))
    return offerIds.map(id => loadedOfferMap.get(id)).filter(excludeNullOrUndefined)
  }, [loadedOffers, offerIds])

  const totalNumOffers = overrideOfferList?.offerCount || 0

  const fetchingList = (offerList?.offerIds?.length || 0) < totalNumOffers
  const fetchingPage = (overrideOfferList?.offerIds?.length || 0 % pageSize) < pageSize && fetchingList && !overrideOfferList?.streamEnded
  const error = overrideOfferList?.error && !overrideOfferList?.streamEnded
  const allOffersLoaded = !fetchingList && !offersFetching && offers.length === totalNumOffers
  const noOffersAvailable = !fetchingList && totalNumOffers === 0
  const key = overrideOfferList?.key

  return useMemo(() => ({
    offers,
    totalNumOffers,
    fetchingList,
    error,
    allOffersLoaded,
    noOffersAvailable,
    key,
    fetchingPage,
  }), [offers, totalNumOffers, fetchingList, error, allOffersLoaded, noOffersAvailable, key, fetchingPage])
}
